// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"3cf72f50","488":"7213179a"}[chunkId] + ".chunk.js";
};